import {Box, Flex, HStack, Spinner, Stack, Switch, Text} from "@chakra-ui/react"
import {Pressable} from "components"
import {useEffect, useRef, useState} from "react"

export default function Switcher({title, description, value, loading, isDisabled, ...props}) {

    return (
        <Pressable isDisabled={loading || isDisabled} {...props}>
            <Box borderRadius="10px" w="100%" backgroundColor="rgba(0,0,0,0.03)">
                <Flex>
                    <HStack w="100%">
                        <Flex minH="65px" alignItems="center" justifyContent="center" w="20%"
                              backgroundColor={value ? 'green.50' : 'red.100'} h="100%" borderRadius="10px">
                            {loading ? <Spinner size="sm"/> : <Text children={value ? '✅' : '⛔'}/>}
                        </Flex>
                        <Box w="80%" p={2}>
                            <Text fontSize="sm" fontWeight="500" children={title}/>
                            <Text fontSize="xs" color="GrayText" children={description} lineHeight="0.8rem"/>
                        </Box>
                    </HStack>
                </Flex>
            </Box>
        </Pressable>
    )
}